import DeviceListItem from './DeviceListItem';

export default DeviceListItem;



// WEBPACK FOOTER //
// ./src/components/DeviceListItem/index.js